import { useState } from "react";
import { faqs, siteMeta } from "../../../mocks/gossip";
import type { Faq } from "../../../types";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-3xl px-4 md:px-8 py-10 md:py-14">
        <div className="text-center mb-8">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1 text-xs font-medium mb-3">
            <i className="ri-question-line" aria-hidden="true"></i> 常见问题
          </span>
          <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">关于吃瓜，你可能想问</h2>
          <p className="text-foreground-500 text-sm mt-1.5">理性围观，不造谣、不传谣，做一个清醒的吃瓜群众</p>
        </div>

        <div className="space-y-3">
          {faqs.map((f: Faq, i) => {
            const open = openIdx === i;
            return (
              <div key={i} className={`rounded-xl bg-background-50 overflow-hidden transition ${open ? "ring-1 ring-primary-200" : ""}`}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="font-heading font-semibold text-foreground-900 text-sm md:text-base">{f.q}</span>
                  <span className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition ${open ? "bg-primary-600 text-background-50" : "bg-background-100 text-foreground-600"}`}>
                    <i className={`ri-add-line transition-transform ${open ? "rotate-45" : ""}`} aria-hidden="true"></i>
                  </span>
                </button>
                {open && <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>}
              </div>
            );
          })}
        </div>

        <p className="text-center text-sm text-foreground-500 mt-7">
          还有其他疑问？欢迎通过 <a href={`mailto:${siteMeta.email}`} className="text-primary-600 hover:text-primary-700 font-medium">{siteMeta.email}</a> 联系我们
        </p>
      </div>
    </section>
  );
}